import React, { Component }  from 'react';
import { Image, Header, Button } from 'semantic-ui-react';
import NumberFormat from 'react-number-format';
import { Link } from 'react-router-dom';
import { withAuth0 } from '@auth0/auth0-react';

class ExploreContent extends Component {
  constructor() {
    super();
    this.state = {
      count: 0
    };
  }

  componentDidMount() {
    // update data
    const { name } = this.props;
    const url = `/go/api/v1/${name}/count`;
    fetch(url).then(res => {
      return res.json();
    }).then(count => {
      if (!isNaN(count)) {
        this.setState({ count: count });
      }
    }).catch(console.error);
  }

  render() {
    const { name, title, auth0 } = this.props;
    const { count } = this.state;
    const img = `/img/explore-${name}.png`;
    const url = `/${name}`;
    const { isAuthenticated } = auth0;

    return (
      <React.Fragment>
        <Image src={img} fluid />
        <Header as='h2'>{title}</Header>
        {this.props.children}
        <small className='muted'>
          <NumberFormat value={count} displayType='text' thousandSeparator={true} /> records
        </small>
        {isAuthenticated && (<Button as={Link} to={url} basic icon='arrow right'fluid />)}
      </React.Fragment>
    );
  }
}
export default withAuth0(ExploreContent);
